module.exports = fetch;
